import {
	Component, ChangeDetectionStrategy, Input, Output, EventEmitter,
	OnInit
} from '@angular/core';
import {ISelectionBoxItem} from "../../../interfaces/Iselection.box.item";


@Component({
	selector: 'cp-sb-selection-diagram',
	templateUrl: './selection.diagram.html',
	styleUrls: ['./selection.diagram.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionDiagramComponent {//} implements OnInit {

	@Input() data: ISelectionBoxItem[];
	@Input() diagramPath: string;

	@Output() selectItem: EventEmitter<ISelectionBoxItem> = new EventEmitter<ISelectionBoxItem>();

	//public diagram;

	// private diagrams = {
	// 	'./diagram.png' : require("./diagram.png")
	// };

	// public ngOnInit() {
	// 	//this.diagram = this.diagrams[this.diagramPath];
	// }

	public getRadius(item: ISelectionBoxItem) {
		return item.isActive ? 8 : 6;
	}

	public onSelect(item: ISelectionBoxItem) {
		this.selectItem.emit(item);
	}
}
